import * as React from 'react';

function SvgNavReferral(props) {
  return (
    <svg width={16} height={16} viewBox="0 0 13 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.249 0a3.804 3.804 0 013.834 3.834c0 2.05-1.693 3.834-3.834 3.834a3.804 3.804 0 01-3.835-3.834A3.804 3.804 0 017.25 0zm.508 8.5H5.768C2.466 8.5 0 10.727 0 13.961v.348C0 16 2.643 16 5.988 16h2.237A5.485 5.485 0 016.5 12c0-1.33.472-2.55 1.257-3.5zM16 12a4 4 0 11-8 0 4 4 0 018 0zm-3.276-2.424a.6.6 0 00-.848.848l.976.976H9.8a.6.6 0 100 1.2h3.051l-.975.976a.6.6 0 00.848.848L15.15 12l-2.425-2.424z"
      />
    </svg>
  );
}

export default SvgNavReferral;
